export default __webpack_public_path__ + "static/media/return_icon_blk.50052d00.svg";